(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.hero-section');

    if (!section) return;

    const slides = Array.from(section.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
    const prevButton = section.querySelector('[data-hero-prev]');
    const nextButton = section.querySelector('[data-hero-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5000;
    const parallaxEnabled = section.dataset.parallax === 'true';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mediaItems = Array.from(section.querySelectorAll('[data-hero-media]'));
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let autoplayTimer = null;

    if (activeIndex < 0) activeIndex = 0;

    const updateSlides = (index) => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      activeIndex = index;
    };

    const goToSlide = (index) => {
      const normalizedIndex = (index + slides.length) % slides.length;
      updateSlides(normalizedIndex);
    };

    const startAutoplay = () => {
      if (!autoplay || prefersReducedMotion || slides.length < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(() => {
        goToSlide(activeIndex + 1);
      }, autoplaySpeed);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
    };

    prevButton?.addEventListener('click', () => {
      goToSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      goToSlide(activeIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    if (parallaxEnabled && !prefersReducedMotion) {
      let ticking = false;

      const updateParallax = () => {
        const rect = section.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const translateY = (progress - 0.5) * 40;

        mediaItems.forEach((media) => {
          media.style.transform = `translate3d(0, ${translateY}px, 0) scale(1.08)`;
        });

        ticking = false;
      };

      const requestParallaxUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      document.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
    }

    updateSlides(activeIndex);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sw-testimonials')) return;

    class SWTestimonials extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this.track = this.querySelector('[data-sw-track]');
        this.cards = this.track ? Array.from(this.track.querySelectorAll('.sw-t-card')) : [];
        if (!this.track || !this.cards.length) return;

        this.controls = this.querySelector('[data-sw-controls]');
        this.prev = this.querySelector('[data-sw-prev]');
        this.next = this.querySelector('[data-sw-next]');
        this.currentLabel = this.querySelector('[data-sw-current]');
        this.totalLabel = this.querySelector('[data-sw-total]');
        this.fill = this.querySelector('[data-sw-fill]');
        this._perPage = this.getPerPage();

        this._onScroll = () => {
          if (this._frame) cancelAnimationFrame(this._frame);
          this._frame = requestAnimationFrame(() => this.update());
        };
        this._onResize = () => {
          const newPerPage = this.getPerPage();
          if (newPerPage !== this._perPage) {
            this._perPage = newPerPage;
            this.track.scrollTo({ left: 0, behavior: 'auto' });
          }
          this.update();
        };
        this._onBlockSelect = (event) => {
          const selectedCard = event.target.closest('.sw-t-card');
          if (!selectedCard || !this.contains(selectedCard)) return;
          const targetLeft = selectedCard.offsetLeft - this.cards[0].offsetLeft;
          this.track.scrollTo({ left: targetLeft, behavior: 'auto' });
        };
        this._onPrevious = () => this.move(-1);
        this._onNext = () => this.move(1);

        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this._onBlockSelect);
        this.prev.addEventListener('click', this._onPrevious);
        this.next.addEventListener('click', this._onNext);
        window.addEventListener('resize', this._onResize, { passive: true });
        this._initialized = true;
        this.update();
      }

      disconnectedCallback() {
        if (!this._initialized) return;
        this.track.removeEventListener('scroll', this._onScroll);
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
        this.prev.removeEventListener('click', this._onPrevious);
        this.next.removeEventListener('click', this._onNext);
        window.removeEventListener('resize', this._onResize);
        if (this._frame) cancelAnimationFrame(this._frame);
        this._initialized = false;
      }

      getPerPage() {
        if (window.matchMedia('(max-width: 749px)').matches) return 1;
        if (window.matchMedia('(max-width: 989px)').matches) return 2;
        return 3;
      }

      getPage() {
        if (!this.cards.length) return 0;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const cardWidth = this.cards[0].getBoundingClientRect().width + gap;
        const cardIndex = cardWidth > 0 ? Math.round(this.track.scrollLeft / cardWidth) : 0;
        const total = Math.max(1, Math.ceil(this.cards.length / this._perPage));
        return Math.max(0, Math.min(total - 1, Math.round(cardIndex / this._perPage)));
      }

      move(direction) {
        const total = Math.ceil(this.cards.length / this._perPage);
        const destinationPage = Math.min(total - 1, Math.max(0, this.getPage() + direction));
        const firstCard = Math.min(destinationPage * this._perPage, Math.max(0, this.cards.length - this._perPage));
        const targetLeft = this.cards[firstCard].offsetLeft - this.cards[0].offsetLeft;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        if (!this.cards.length) return;
        const total = Math.max(1, Math.ceil(this.cards.length / this._perPage));
        const current = this.getPage();
        this.currentLabel.textContent = String(current + 1).padStart(2, '0');
        this.totalLabel.textContent = String(total).padStart(2, '0');
        this.fill.style.width = (((current + 1) / total) * 100) + '%';
        this.prev.disabled = current === 0;
        this.next.disabled = current >= total - 1;
        this.controls.hidden = total < 2;
      }
    }

    customElements.define('sw-testimonials', SWTestimonials);
  })();

  } catch(e) { console.error(e); }
})();
})();
